<template>
    <div>
        <div class="header mt-5 mb-0">
            {{ $vuetify.lang.t('$vuetify.inquiry.inquiryAndAttendance') }}
        </div>
        <nav-bar
            ref="navBar"
            @menu-change="menuChange"
            :menuItem="navBarList">
        </nav-bar>

        <component :is="component" />
    </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import Inquiry from '@/components/InquiryAndAttendance/Inquiry.vue'
import StatusAttendance from '@/components/InquiryAndAttendance/StatusAttendance.vue'
import ManageAttendance from '@/components/InquiryAndAttendance/ManageAttendance.vue'
import PunchLog from '@/components/InquiryAndAttendance/PunchLog.vue'

export default {
    name: 'InquiryAndAttendance',

    components: {
        NavBar,
        Inquiry,
        StatusAttendance,
        ManageAttendance,
        PunchLog
    },

    computed: {
        navBarList () {
            const navBarList = []
            for (const menuItem of this.menuItems) {
                navBarList.push(menuItem)
            }
            return navBarList
        }
    },

    data () {
        return {
            component: 'Inquiry',
            menuItems: [
                {
                    title: this.$vuetify.lang.t('$vuetify.inquiry.inquiry'),
                    path: 'Inquiry',
                    pathName: 'inquiry',
                    permission: []
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.inquiry.statusAttendance'),
                    path: 'StatusAttendance',
                    pathName: 'status-attendance',
                    permission: []
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.inquiry.manageAttendance'),
                    path: 'ManageAttendance',
                    pathName: 'manage-attendance',
                    permission: []
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.inquiry.punchLog'),
                    path: 'PunchLog',
                    pathName: 'punch-log',
                    permission: []
                }
            ],
            mappedTranslation: {
                Inquiry: 'inquiry',
                StatusAttendance: 'statusAttendance',
                ManageAttendance: 'manageAttendance',
                PunchLog: 'punchLog'
            }
        }
    },

    methods: {
        menuChange (payload) {
            this.component = payload.path

            const path = `/inquiry-and-attendance/${this.menuItems[payload.index].pathName}`
            if (this.$route.path !== path) {
                this.$router.replace(path)
            }
        },

        navBarPermission () {
            this.component = this.navBarList[0].path
        },

        hideServiceFromEnv () {
            if (process.env.VUE_APP_PUNCH_LOG === 'false') {
                const indexOfPinMenu = this.menuItems.findIndex((menu, index) => {
                    if (menu.path === 'PunchLog') {
                        return true
                    }
                })

                this.menuItems.splice(indexOfPinMenu, 1)
            }

            if (process.env.VUE_APP_CHECK_IN_LOCATION === 'false') {
                const indexOfCheckInLocationMenu = this.menuItems.findIndex((menu, index) => {
                    if (menu.path === 'CheckInLocation') {
                        return true
                    }
                })

                this.menuItems.splice(indexOfCheckInLocationMenu, 1)
            }
        },

        setLangNavBar () {
            for (const menuItem of this.menuItems) {
                if (this.mappedTranslation[menuItem.path]) {
                    menuItem.title = this.$vuetify.lang.t(`$vuetify.inquiry.${this.mappedTranslation[menuItem.path]}`)
                }
            }
        },

        setActive (path) {
            let index = 0
            if (path === 'InquiryAndAttendance') {
                this.$refs.navBar.go(this.menuItems[0].pathName, index)
            } else {
                index = this.menuItems.findIndex(x => x.path === path)
                this.$refs.navBar.go(path, index)
            }

            const directPath = `/inquiry-and-attendance/${this.menuItems[index].pathName}`
            if (this.$route.path !== directPath) {
                this.$router.replace(directPath)
            }
        }
    },

    mounted () {
        this.hideServiceFromEnv()
        this.navBarPermission()
        this.setActive(this.$router.currentRoute.name)
    },

    watch: {
        '$vuetify.lang.current': {
            handler: function (after, before) {
                this.setLangNavBar()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>

.header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2rem;
    font-size: 28px;
    font-weight: bold;
}
</style>
